import classNames from 'classnames';
import styles from './M31ProductGrid.module.scss';
import { M31ProductGridCardProps, M31ProductGridCard } from 'ui/components/2-molecules/Card/M31ProductGridCard/M31ProductGridCard';
import { Container } from 'ui/components/4-habitats/Container/Container';
import { AcademyGridCard, AcademyGridCardProps } from 'ui/components/2-molecules/Card/AcademyGridCard/AcademyGridCard';

export interface M31ProductGridProps {
	className?: string;
	heading?: string;
	gridItems?: M31ProductGridCardProps[] | AcademyGridCardProps[];
	isAcademyView?: boolean;
	dictionary?: { [key: string]: string };
}

export const M31ProductGrid: React.FC<M31ProductGridProps> = ({ heading, className, gridItems, dictionary, isAcademyView }) => {
	return (
		<Container width="StandardWeb" className={classNames(styles.M31ProductGrid, className)}>
			{heading && <h2 className={styles.M31ProductGrid_heading}>{heading}</h2>}
			{gridItems?.length > 0 && (
				<div className={styles.M31ProductGrid_itemsContainer}>
					{gridItems.map((item, index) => (
						<div key={index} className={styles.M31ProductGrid_item}>
							{isAcademyView ? (
								<AcademyGridCard
									{...item?.content?.properties}
									className={classNames(styles.M31ProductGrid_cardItem)}
									buttonStyle="secondaryWeb"
								/>
							) : (
								<M31ProductGridCard {...item} className={classNames(styles.M31ProductGrid_cardItem)} />
							)}
						</div>
					))}
				</div>
			)}
		</Container>
	);
};
